"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OVERSPENDING_MAPPER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var TableRow_1 = __importDefault(require("atomicComponents/atoms/Table/TableRow"));
var ErrorStatsBadge_1 = __importDefault(require("atomicComponents/molecules/Badge/ErrorStatsBadge"));
var SuccessStatsBadge_1 = __importDefault(require("atomicComponents/molecules/Badge/SuccessStatsBadge"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Money_1 = __importDefault(require("components/Money"));
var ServiceCell_1 = __importDefault(require("containers/MyStack/styles/ServiceCell"));
var fieldProcessors_1 = require("../../../utils/fieldProcessors");
var utils_1 = require("./utils");
exports.OVERSPENDING_MAPPER = {
    overspending: 'Overspending',
    optimalPrice: 'Optimal Price',
    notEnoughData: 'Not Enough Data',
};
var showPercentageValue = function (change) {
    if (change > 0)
        return (0, jsx_runtime_1.jsx)(SuccessStatsBadge_1.default, { label: (0, fieldProcessors_1.percentage)(Math.abs(change)), size: "xs" });
    if (change < 0)
        return (0, jsx_runtime_1.jsx)(ErrorStatsBadge_1.default, { label: (0, fieldProcessors_1.percentage)(Math.abs(change)), size: "xs" });
    return '0%';
};
var SaaSAnalysedRow = function (_a) {
    var _b, _c, _d;
    var serviceStat = _a.serviceStat;
    return ((0, jsx_runtime_1.jsxs)(TableRow_1.default, { children: [(0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 190, sx: { pl: 1 }, flex: "none", position: "relative" }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: serviceStat.service, size: "md_table" }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ minWidth: 155, textAlign: "right" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: ((_b = serviceStat.toolAnalysis) === null || _b === void 0 ? void 0 : _b.missedOpportunityAmount) || 0, isRounded: true }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ minWidth: 200, textAlign: "right" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: ((_c = serviceStat.toolAnalysis) === null || _c === void 0 ? void 0 : _c.last12MonthSpend) || 0, isRounded: true }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ minWidth: 180, textAlign: "right" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: utils_1.FieldProcessors.forecastSpend(serviceStat), isRounded: true }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ minWidth: 130, textAlign: "right" }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end" }, { children: showPercentageValue(utils_1.FieldProcessors.change(serviceStat)) })) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ minWidth: 200 }, { children: exports.OVERSPENDING_MAPPER[(_d = serviceStat.toolAnalysis) === null || _d === void 0 ? void 0 : _d.overspendType] }))] }));
};
exports.default = SaaSAnalysedRow;
